export class DefinedMetaElementPlausiPropertyDef {
  public static readonly SENSOR_CURRENT_CONSUMPTION: string = 'sensorCurrentConsumption';
  public static readonly LOGIC_CURRENT_CONSUMPTION: string = 'logicCurrentConsumption';
  public static readonly ACTUATOR_CURRENT_CONSUMPTION: string = 'actuatorCurrentConsumption';
}
